/**
 * B_CanvasGame.js
 *
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Canvas from 'canvas/base/dev/frame/B_Canvas'
import B_Define from 'canvas/base/dev/util/B_Define';
import B_Util   from 'canvas/base/dev/util/B_Util'

const B_CanvasGame = (function(){

	const $ = {
		_speed : null,
	};

	class B_CanvasGame extends B_Canvas {

		constructor(wrapper, id, queue, cb) {
			super(wrapper, id, queue, cb);

			// [S] speed
			if(!B_Util.checkSpeed(this.spd)) this.spd = B_Define.SPEED;
			this.speed = this.spd;
		}

		// @DES(public) :: speed {num} - 스피드 객체 (Ticker 동시 업데이트)
		get speed() { return $._speed; }
		set speed(s) {
			if(!B_Util.checkSpeed(s)) { B_Util.print('[코드모스] => 스피드가 올바르지 않습니다.'); return; }
			$._speed = s;
			createjs.Ticker.setFPS(B_Define.FPS * s);
		}

	};
	B_Util.manageGetAndSet(B_CanvasGame, $);
	return B_CanvasGame;
}());

export default B_CanvasGame;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/frame/B_CanvasGame.js